import { render, staticRenderFns } from "./footerpage.vue?vue&type=template&id=23f6ef11"
import script from "./footerpage.vue?vue&type=script&lang=js"
export * from "./footerpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports